module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/85ec1ef9814530e2979840e6597a4fad.svg";